import React from "react";
import { Row, Col } from "reactstrap";
import "./success.scss";
import { Component } from "react";

class Success extends Component {
  render() {
    return (
      <div className="success-container">
        <Row className="m-0 p-0 ">
          <Col lg="6" className="m-0 p-0 text-right left-col">
            <img
              className="logo m-hide"
              src={require("../../../assets/images/logo-toffee.png")}
              alt=""
            />
            {/* <InsuranceCard data={this.state} /> */}
            <img
              src={require("../../../assets/images/success-img.png")}
              alt=""
            />
          </Col>
          <Col lg="6" className="m-0 p-0 right-col text-left">
            <h2 className="title opacity-90">Success!</h2>
            <h3 className="sub-title">
              You have been successfully registered for the invitation.
            </h3>

            <h3 className="opacity-90 font-weight-bold details-text">
              Check your email for more details.
            </h3>
            <br />
            <br />
            <a className="toffee-link" href="https://toffeeinsurance.com">
              Close
            </a>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Success;
